import { createAction } from 'redux-actions'

import { uuid } from '@albacross/frontend-utils'

import c from 'constants/notification-constants'

// Notifications render as text, so coerce a non-string message to something readable instead of "[object Object]".
const toMessage = (message: any): string => {
  if (typeof message === 'string') return message
  if (typeof message?.message === 'string') return message.message
  try {
    return JSON.stringify(message)
  } catch {
    return String(message)
  }
}

export const addNotification =
  (message: any, type = 'info') =>
  (d: any) =>
    d(createAction(c.ADD)({ id: uuid(), message: toMessage(message), type }))

export const removeNotification = createAction(c.REMOVE)
